import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { parseQueryString } from '@zg-rentals/string-utils';

import { Alert, CloseButton, TextButton } from '@zillow/constellation-10';

import { PartialMessage } from '@zg-rentals/backend-styled-components';
import MultiToSingleFamilyConversionModal from '../../../../components/Modal/MultiToSingleFamilyConversionModal';

const RestrictionsBanner = () => {
  const location = useLocation();

  const {
    active,
    isMultifamily,
    selfServeOnboardingStatus: { isSelfServeOnboardingInProgress },
    multiToSingleFamilyConversion: { isConversionRequired },
    updateActiveStatus: { partialMessages, isAllowed: isUpdateActiveStatusAllowed },
  } = useSelector((state) => state.properties.currentProperty);

  const [showMultiToSingleFamilyConversionModal, setShowMultiToSingleFamilyConversionModal] = useState(false);

  const { convertToSingleFamilyListing } = parseQueryString(location.search);
  const initialShowConversionModal = convertToSingleFamilyListing === 'true';

  useEffect(() => {
    setShowMultiToSingleFamilyConversionModal(initialShowConversionModal);
  }, [initialShowConversionModal]);

  const handleConvertClick = () => {
    setShowMultiToSingleFamilyConversionModal(true);
  };

  // do not display banner if listing is active
  // we will handle deactivation restrictions another way
  if (!isUpdateActiveStatusAllowed && !active && isMultifamily && !isSelfServeOnboardingInProgress) {
    return (
      <div data-testid="RestrictionsBanner">
        <Alert
          tone="warning"
          actionButton={isConversionRequired && <TextButton onClick={handleConvertClick}>Convert</TextButton>}
          closeButton={<CloseButton />}
          css={{ marginBottom: '600' }}
        >
          <PartialMessage partialMessages={partialMessages} />
        </Alert>
        {showMultiToSingleFamilyConversionModal && isConversionRequired && (
          <MultiToSingleFamilyConversionModal
            setShowMultiToSingleFamilyConversionModal={setShowMultiToSingleFamilyConversionModal}
          />
        )}
      </div>
    );
  }

  return null;
};

export default memo(RestrictionsBanner);
